
import Avatar from '../icons/Avatar.vue'

export default {
  components: {
    Avatar,
  },
  methods: {
    login () {
      this.$auth.loginWith('auth0').then(() => {
        localStorage.setItem('redirectTo', this.$route.path)
      })
    },
  },
}
